import React from "react";

// 국기 아이콘 이미지 경로 (사용자가 assets/images 폴더에 추가할 예정)
// 예: ko-flag.png, en-flag.png, zh-flag.png, ja-flag.png, vi-flag.png

export const LanguageFlag: React.FC<{
  locale: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}> = ({ locale, width = 16, height = 12, style = {} }) => {
  // 국기 이미지 경로 매핑
  const flagImages: Record<string, string> = {
    ko: require("./ko-flag.png"),
    en: require("./en-flag.png"),
    zh: require("./zh-flag.png"),
    ja: require("./ja-flag.png"),
    vi: require("./vi-flag.png"),
    es: require("./es-flag.png"),
  };

  const flagSrc = flagImages[locale] || flagImages.ko;

  return (
    <img
      src={flagSrc}
      alt={`${locale} flag`}
      style={{
        width,
        height,
        objectFit: "cover",
        ...style,
      }}
    />
  );
};

